import { Option } from 'components/ReactSelect/ReactSelect'

export const PAGE_SIZE = 10

export const timeFilterOptions: Option[] = [
  { value: '24h', label: '24h' },
  { value: '7d', label: '7d' },
  { value: '30d', label: '30d' },
  { value: '3m', label: '3m' },
]

export enum NewPositionQueryParams {
  configId = 'configId',
  minPrice = 'minPrice',
  maxPrice = 'maxPrice',
}

export const walletsSortMobileOptions: Option[] = [
  { value: 'openEquity (desc)', label: 'Open equity (desc)' },
  { value: 'openEquity (asc)', label: 'Open equity (asc)' },
  { value: 'totalPnl (desc)', label: 'PnL (desc)' },
  { value: 'totalPnl (asc)', label: 'PnL (asc)' },
  { value: 'totalReturnOnEquity (desc)', label: 'ROI (desc)' },
  { value: 'totalReturnOnEquity (asc)', label: 'ROI (asc)' },
  { value: 'totalHodlBenchmarkPnl (desc)', label: 'HODL (desc)' },
  { value: 'totalHodlBenchmarkPnl (asc)', label: 'HODL (asc)' },
  { value: 'totalPositions (desc)', label: 'Positions (desc)' },
  { value: 'totalPositions (asc)', label: 'Positions (asc)' },
]

export const positionsSortMobileOptions: Option[] = [
  { value: 'positionCreationTimestampMs (desc)', label: 'Date (desc)' },
  { value: 'positionCreationTimestampMs (asc)', label: 'Date (asc)' },
  { value: 'timeWeightedEquity (desc)', label: 'Equity (desc)' },
  { value: 'timeWeightedEquity (asc)', label: 'Equity (asc)' },
  { value: 'aprFull (desc)', label: 'APR (desc)' },
  { value: 'aprFull (asc)', label: 'APR (asc)' },
  { value: 'pnl (desc)', label: 'PnL (desc)' },
  { value: 'pnl (asc)', label: 'PnL (asc)' },
  { value: 'returnOnEquity (desc)', label: 'ROI (desc)' },
  { value: 'returnOnEquity (asc)', label: 'ROI (asc)' },
  { value: 'hodlBenchmarkPnl (desc)', label: 'HODL (desc)' },
  { value: 'hodlBenchmarkPnl (asc)', label: 'HODL (asc)' },
]
